import classNames from 'classnames';
import { Skeleton } from '@medifind/shared-basic-components';
import { getSmallClassList, getValueMediaBreakpointDown } from '@medifind/utils';
import styles from './CardRatings.module.scss';

const CardRatings = ({ data, highlyRatedConditionsCount, highlyRatedIn, smallAt = ['xs', 'sm', 'md'] }) => {
  const { smallClassList } = getSmallClassList(smallAt, styles);
  return (
    <div
      className={classNames(
        styles['ratings'],
        {
          ['hide--always']: data && (!highlyRatedConditionsCount || highlyRatedConditionsCount === 0),
        },
        smallClassList,
      )}
    >
      {data ? (
        <>
          Expertise in <div>{highlyRatedConditionsCount}</div> {highlyRatedIn ? highlyRatedIn : 'conditions'}
        </>
      ) : (
        <Skeleton height={getValueMediaBreakpointDown({ xs: 20, sm: 80, md: 80, lg: 20, default: 80 })} />
      )}
    </div>
  );
};

export { CardRatings as default, CardRatings };
